export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SELECT_BOAT = 'SELECT_BOAT';
export const ADD_BOAT = 'ADD_BOAT';
export const LIST_BOATS = 'LIST_BOATS';
export const BOOKING_CARD = 'BOOKING_CARD';
export const SIMILAR_BOATS = 'SIMILAR_BOATS';
export const CHECKOUT_DATA = 'CHECKOUT_DATA';
export const USER_PROFILE = 'USER_PROFILE';
export const CONVERSATION = 'CONVERSATION';
export const LOCATION = 'LOCATION';
export const AUTH_IS_READY = 'AUTH_IS_READY';
export const UPDATE_BOAT_RATING = 'UPDATE_BOAT_RATING';
